export const UI_THEMES = {
  aurora: { id: 'aurora', label: 'Navy blue' },
  paper: { id: 'paper', label: 'Paper white' },
  slate: { id: 'slate', label: 'Slate dark' },
};

export const UI_THEME_ORDER = ['paper', 'aurora', 'slate'];

/** Bumped so existing navy preference is not sticky while previewing paper. */
export const UI_THEME_KEY = 'uiTheme.v2';
export const UI_THEME_EVENT = 'ui-theme-change';

export function getUiTheme() {
  const stored = localStorage.getItem(UI_THEME_KEY);
  if (stored && UI_THEMES[stored]) return stored;
  return 'paper';
}

export function nextUiTheme(current) {
  const i = UI_THEME_ORDER.indexOf(current);
  return UI_THEME_ORDER[(i < 0 ? 0 : i + 1) % UI_THEME_ORDER.length];
}

export function applyUiTheme(theme) {
  const id = UI_THEMES[theme] ? theme : 'paper';
  document.documentElement.setAttribute('data-theme', id);
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) {
    themeColor.setAttribute('content', id === 'paper' ? '#dfe5ee' : '#0f172a');
  }
}

export function setUiTheme(theme) {
  const next = UI_THEMES[theme] ? theme : 'paper';
  localStorage.setItem(UI_THEME_KEY, next);
  applyUiTheme(next);
  window.dispatchEvent(new Event(UI_THEME_EVENT));
}

export function initUiTheme() {
  applyUiTheme(getUiTheme());
}
